export default __webpack_public_path__ + "static/N0271-a3f4b7fdda070b75f8b472585b0148bd.png";